import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrintDirectionsComponent } from './components/print-directions/print-directions.component';
import { MapContainerComponent } from './components/map-container/map-container.component';

const routes: Routes = [
  {path: "**/:lat/:lng", component: MapContainerComponent},
  {path: 'print', component: PrintDirectionsComponent},
  {path: "**", component: MapContainerComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }